import React, { useState, useEffect } from 'react';
import {
  Upload,
  FileText,
  Send,
  CheckCircle,
  XCircle,
  BookOpen,
  Camera,
  Loader,
  User,
  BarChart3,
  Award,
  Star,
  Trophy,
  Zap,
} from 'lucide-react';
import Tesseract from 'tesseract.js';
import './Gamification.css';

// DODANO 2025-10-26 14:40: Import komponentu poziomu trudności
import DifficultySelector, { DIFFICULTY_LEVELS } from './components/DifficultySelector';

// KONFIGURACJA API - ZMIEŃ NA SWÓJ ADRES!
const API_BASE = '/nauczyciel-ai/api';

export default function TeacherAI() {
  // --- STANY PODSTAWOWE (z App.js) ---
  const [stage, setStage] = useState('name');
  const [studentName, setStudentName] = useState('');
  const [sessionId, setSessionId] = useState(null);
  const [material, setMaterial] = useState('');
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [textInput, setTextInput] = useState('');
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isProcessingOCR, setIsProcessingOCR] = useState(false);
  const [ocrProgress, setOcrProgress] = useState(0);
  const [studentStats, setStudentStats] = useState(null);
  const [studentMaterials, setStudentMaterials] = useState([]);
  const [sessionStartTime, setSessionStartTime] = useState(null);
  const [isGeneratingAI, setIsGeneratingAI] = useState(false);
  const [useAI, setUseAI] = useState(true);
  // DODANO 2025-10-26 14:40: State dla poziomu trudności (domyślnie: Klasy 5-8)
  const [difficultyLevel, setDifficultyLevel] = useState(2);


   // --- NOWE: konfiguracja quizu / gamifikacja ---
  const [questionCount, setQuestionCount] = useState(6);
  const [showConfig, setShowConfig] = useState(false);

  // DODAJ TĘ LINIĘ: state dla wyszukiwania
  const [materialSearchQuery, setMaterialSearchQuery] = useState('');

  // gamification state
  const [studentProgress, setStudentProgress] = useState(null); // { level, total_xp, ... }
  const [earnedXP, setEarnedXP] = useState(0);
  const [levelUp, setLevelUp] = useState(false);
  const [newBadges, setNewBadges] = useState([]);
  const [showXPAnimation, setShowXPAnimation] = useState(false);

  // --- Ładowanie statystyk + progresu gracza ---
  useEffect(() => {
    if (studentName && stage === 'name') {
      loadStudentStats();
      loadStudentProgress();
    }
  }, [studentName, stage]);

  // DODANO 2025-10-26 14:40: Zapisz/wczytaj poziom trudności z localStorage
  useEffect(() => {
    if (difficultyLevel) {
      localStorage.setItem('preferredDifficulty', difficultyLevel.toString());
    }
  }, [difficultyLevel]);

  useEffect(() => {
    const saved = localStorage.getItem('preferredDifficulty');
    if (saved) {
      setDifficultyLevel(parseInt(saved));
    }
  }, []);

  const loadStudentStats = async () => {
    try {
      const response = await fetch(
        `${API_BASE}/results.php?student=${encodeURIComponent(studentName)}`
      );
      const data = await response.json();
      if (data.success && data.data.total_sessions > 0) {
        setStudentStats(data.data);
      }
    } catch (error) {
      console.error('Błąd ładowania statystyk:', error);
    }
  };

  // gamification.php?action=get_progress&student=...
  const loadStudentProgress = async () => {
    try {
      const response = await fetch(
        `${API_BASE}/gamification.php?action=get_progress&student=${encodeURIComponent(
          studentName
        )}`
      );
      const data = await response.json();
// ZMIEŃ NA:
if (data.success && data.data && data.data.progress) {
  setStudentProgress(data.data.progress); // ✅ DODAJ .progress
}


    } catch (error) {
      console.error('Błąd ładowania postępów:', error);
    }
  };

  // ============================================
// FRAGMENT KODU DO WKLEJENIA W App.js
// Linia ~95-110 - funkcja loadStudentMaterials
// ============================================

/**
 * Ładuje WSZYSTKIE materiały (globalne dla wszystkich uczniów)
 * ZMIENIONO: Usunięto parametr ?student=... z URL
 */
const loadStudentMaterials = async () => {
  try {
    // Bez parametru student - pobieramy wszystkie materiały
    const response = await fetch(`${API_BASE}/materials.php`);
    const data = await response.json();
    
    if (data.success && data.data.length > 0) {
      setStudentMaterials(data.data);
    } else {
      setStudentMaterials([]);
    }
  } catch (error) {
    console.error('Błąd ładowania materiałów:', error);
    setStudentMaterials([]);
  }
};

  const loadPreviousMaterial = (materialText) => {
    setTextInput(materialText);
    setMaterial(materialText);
    setTimeout(() => {
      document.querySelector('textarea')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  // --- WEJŚCIE IMIENIA / START SESJI ---
  const startSession = async () => {
    if (!studentName.trim()) {
      alert('Wpisz swoje imię!');
      return;
    }
    await loadStudentMaterials();
    setStage('upload');
  };

  // --- OCR ZDJĘCIA PODRĘCZNIKA ---
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      setUploadedImage(event.target.result);
    };
    reader.readAsDataURL(file);

    setIsProcessingOCR(true);
    setOcrProgress(0);

    try {
      const result = await Tesseract.recognize(file, 'pol', {
        logger: (m) => {
          if (m.status === 'recognizing text') {
            setOcrProgress(Math.round(m.progress * 100));
          }
        },
      });

      const extractedText = result.data.text.trim();

      if (extractedText && extractedText.length > 20) {
        setTextInput(extractedText);
        setMaterial(extractedText);
        alert('✓ Tekst został pomyślnie rozpoznany ze zdjęcia!');
      } else {
        alert(
          '⚠️ Nie udało się rozpoznać wystarczającej ilości tekstu. Spróbuj lepszego zdjęcia lub przepisz ręcznie.'
        );
      }
    } catch (error) {
      console.error('OCR Error:', error);
      alert(
        '❌ Wystąpił błąd podczas rozpoznawania tekstu. Przepisz tekst ręcznie.'
      );
    } finally {
      setIsProcessingOCR(false);
      setOcrProgress(0);
    }
  };

  // Ręczne wklejanie tekstu
  const handleTextSubmit = () => {
    if (textInput.trim()) {
      setMaterial(textInput);
    }
  };

  // --- GENERATOR PYTAŃ (bazowy + fallback) ---
  // Uwaga: zaktualizowane pod questionCount
  const generateQuestions = (text) => {
    const sentences = text
      .split(/[.!?]+/)
      .filter((s) => s.trim().length > 20)
      .map((s) => s.trim());

    const allQuestions = [];

    const questionTemplates = {
      definition: ['Co to jest', 'Czym jest', 'Zdefiniuj'],
      process: ['Jak przebiega', 'Jak działa', 'W jaki sposób'],
      reason: ['Dlaczego', 'Z jakiego powodu', 'Jaka jest przyczyna'],
      characteristics: ['Jakie są cechy', 'Wymień właściwości', 'Opisz'],
      comparison: ['Porównaj', 'Na czym polega różnica', 'Czym się różni'],
    };

    sentences.slice(0, 10).forEach((sentence, i) => {
      const trimmedSentence = sentence.trim();
      const words = trimmedSentence.split(' ');
      const meaningfulWords = words.filter((w) => w.length > 4);
      if (meaningfulWords.length === 0) return;

      if (i % 3 === 0) {
        // pytanie otwarte
        const subject = meaningfulWords[0];
        const templates = Object.values(questionTemplates).flat();
        const template = templates[i % templates.length];

        allQuestions.push({
          type: 'open',
          question: `${template} ${subject}?`,
          correctAnswer: trimmedSentence,
          userAnswer: '',
        });
      } else if (i % 3 === 1) {
        // multi choice
        const correct = trimmedSentence;
        const wrongOptions = [];

        if (meaningfulWords.length > 0) {
          const modifiedWords = [...words];
          const keyWordIndex = words.indexOf(meaningfulWords[0]);
          if (keyWordIndex >= 0) {
            modifiedWords[keyWordIndex] = 'inna koncepcja';
          }
          wrongOptions.push(modifiedWords.join(' '));
        }

        const verbVariations = ['jest', 'ma', 'posiada', 'charakteryzuje się'];
        let distractor2 = correct;
        verbVariations.forEach((verb) => {
          if (correct.toLowerCase().includes(verb)) {
            const otherVerb =
              verbVariations.find((v) => v !== verb) || 'nie ma';
            distractor2 = correct.replace(new RegExp(verb, 'gi'), otherVerb);
          }
        });
        if (distractor2 !== correct) wrongOptions.push(distractor2);

        if (correct.includes('jest') || correct.includes('ma')) {
          wrongOptions.push(
            correct.replace(/jest|ma/gi, 'nie jest') + ' tego typu'
          );
        }

        while (wrongOptions.length < 3) {
          wrongOptions.push(
            `To nie dotyczy tematu ${meaningfulWords[0] || 'materiału'}`
          );
        }

        const options = [correct, ...wrongOptions.slice(0, 3)].sort(
          () => Math.random() - 0.5
        );

        allQuestions.push({
          type: 'multiple',
          question: `Które stwierdzenie jest prawdziwe?`,
          options: options,
          correctAnswer: correct,
          selectedOption: null,
        });
      } else {
        // prawda / fałsz
        const isTrue = Math.random() > 0.5;
        let statement;

        if (isTrue) {
          statement = trimmedSentence;
        } else {
          let modifiedStatement = trimmedSentence;

          if (Math.random() > 0.5) {
            modifiedStatement = modifiedStatement.replace(
              /(\bjest\b|\bma\b|\bposiada\b)/gi,
              (match) => 'nie ' + match
            );
          } else if (meaningfulWords.length > 1) {
            const randomWord =
              meaningfulWords[
                Math.floor(Math.random() * meaningfulWords.length)
              ];
            modifiedStatement = modifiedStatement.replace(
              randomWord,
              'przeciwna właściwość'
            );
          } else {
            modifiedStatement =
              modifiedStatement + ', co jest nieprawdą';
          }

          statement = modifiedStatement;
        }

        allQuestions.push({
          type: 'truefalse',
          question: statement,
          correctAnswer: isTrue,
          selectedOption: null,
        });
      }
    });

    return allQuestions.slice(0, questionCount);
  };

  // --- START NAUKI ---
  const startLearning = async () => {
    if (!material) {
      alert('Najpierw dodaj materiał do nauki!');
      return;
    }

    try {
      // 1. utwórz sesję
      const response = await fetch(`${API_BASE}/sessions.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          student_name: studentName,
          material_text: material,
        }),
      });

      const data = await response.json();

      if (!data.success) {
        alert('Błąd tworzenia sesji: ' + data.message);
        return;
      }

      // setSessionId(data.data.session_id);


      const newSessionId = data.data.session_id;
      setSessionId(newSessionId);
      // DODAJ: Zapisz w localStorage jako backup
      localStorage.setItem('currentSessionId', newSessionId);


      // 2. generowanie pytań (AI lub fallback)
      let qs;
      if (useAI) {
        setIsGeneratingAI(true);
        try {
          const aiResponse = await fetch(`${API_BASE}/llm_questions.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              material_text: material,
              question_count: questionCount,
              session_id: newSessionId,    // ← DODAJ
              student_name: studentName,   // ← DODAJ
              difficulty_level: difficultyLevel,  // DODANO 2025-10-26 14:40
            }),
          });

          const aiData = await aiResponse.json();

          if (aiData.success) {
            qs = aiData.data.questions;
          } else {
            alert('AI nie mogło wygenerować pytań, używam zwykłych');
            qs = generateQuestions(material);
          }
        } catch (error) {
          console.error('Błąd AI:', error);
          alert('Błąd AI, używam zwykłych pytań');
          qs = generateQuestions(material);
        } finally {
          setIsGeneratingAI(false);
        }
      } else {
        qs = generateQuestions(material);
      }

      setQuestions(qs);

      // 3. zapisz pytania
      await fetch(`${API_BASE}/questions.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: data.data.session_id,
          questions: qs.map((q) => ({
            question: q.question,
            type: q.type,
            correctAnswer: q.correctAnswer,
            options: q.options || null,
          })),
        }),
      });

      // 4. wejdź w tryb quizu
      setStage('learning');
      setCurrentQuestion(0);
      setAnswers([]);
      setUserAnswer('');
      setSelectedOption(null);
      setSessionStartTime(Date.now());
    } catch (error) {
      console.error('Błąd:', error);
      alert('Wystąpił błąd podczas tworzenia sesji');
    }
  };

  // --- SPRAWDZANIE ODPOWIEDZI ---
  const submitAnswer = async () => {
   // DODAJ TEN LOG:
  console.log('submitAnswer DEBUG:', {
    sessionId: sessionId,
    studentName: studentName,
    type: typeof sessionId
  });
    // koniec dodatków    
    const q = questions[currentQuestion];
    // DODAJ: Pobierz z localStorage jeśli state jest null
    const currentSessionId = sessionId || localStorage.getItem('currentSessionId');
    let isCorrect = false;
    let givenAnswer = '';
    let feedback = '';

    if (q.type === 'open') {
      if (!userAnswer.trim()) return;
      givenAnswer = userAnswer;

      if (useAI) {
        try {
          const evalResponse = await fetch(`${API_BASE}/llm_evaluate.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              question: q.question,
              user_answer: userAnswer,
              correct_answer: q.correctAnswer,
              session_id: currentSessionId,    // Użyj zmiennej
              student_name: studentName,
            }),
          });

          const evalData = await evalResponse.json();

          if (evalData.success) {
            isCorrect = evalData.data.is_correct;
            feedback = evalData.data.feedback || evalData.data.explanation;
          } else {
            const expected = q.correctAnswer.toLowerCase();
            const given = userAnswer.toLowerCase();
            const keywords = expected.split(' ').filter((w) => w.length > 4);
            const matchCount = keywords.filter((k) => given.includes(k))
              .length;
            isCorrect = matchCount >= Math.min(2, keywords.length);
          }
        } catch (error) {
          console.error('Błąd oceny AI:', error);
          const expected = q.correctAnswer.toLowerCase();
          const given = userAnswer.toLowerCase();
          const keywords = expected.split(' ').filter((w) => w.length > 4);
          const matchCount = keywords.filter((k) => given.includes(k)).length;
          isCorrect = matchCount >= Math.min(2, keywords.length);
        }
      } else {
        const expected = q.correctAnswer.toLowerCase();
        const given = userAnswer.toLowerCase();
        const keywords = expected.split(' ').filter((w) => w.length > 4);
        const matchCount = keywords.filter((k) => given.includes(k)).length;
        isCorrect = matchCount >= Math.min(2, keywords.length);
      }
    } else if (q.type === 'multiple') {
      if (selectedOption === null) return;
      givenAnswer = q.options[selectedOption];
      isCorrect = givenAnswer === q.correctAnswer;
    } else if (q.type === 'truefalse') {
      if (selectedOption === null) return;
      givenAnswer = selectedOption === 'true' ? 'Prawda' : 'Fałsz';
      isCorrect = (selectedOption === 'true') === q.correctAnswer;
    }

    const answerData = {
      question: q.question,
      type: q.type,
      userAnswer: givenAnswer,
      isCorrect,
      feedback: feedback,
      correctAnswer:
        q.type === 'open'
          ? q.correctAnswer
          : q.type === 'multiple'
          ? q.correctAnswer
          : q.correctAnswer
          ? 'Prawda'
          : 'Fałsz',
    };

    setAnswers([...answers, answerData]);

    // zapis pojedynczej odpowiedzi do backendu
    if (sessionId) {
      try {
        const questionsResponse = await fetch(
          `${API_BASE}/questions.php?session_id=${sessionId}`
        );
        const questionsData = await questionsResponse.json();
        if (questionsData.success) {
          const questionFromDb = questionsData.data[currentQuestion];

          await fetch(`${API_BASE}/answers.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              question_id: questionFromDb.id,
              session_id: sessionId,
              user_answer: givenAnswer,
              is_correct: isCorrect,
            }),
          });
        }
      } catch (error) {
        console.error('Błąd zapisywania odpowiedzi:', error);
      }
    }

    // przejdź dalej albo zakończ
    setUserAnswer('');
    setSelectedOption(null);

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      await finishSession([...answers, answerData]);
    }
  };

  // --- XP / gamification utils ---
  const calculateXP = (correctCount, totalQuestions, timeSpent, percentage) => {
    let xp = 0;

    // bazowe
    xp += 10;
    // za poprawne odpowiedzi
    xp += correctCount * 5;
    // 100%
    if (percentage === 100) xp += 50;
    // szybkość (<30s/pyt.)
    const avgTimePerQuestion = timeSpent / totalQuestions;
    if (avgTimePerQuestion < 30) xp += 20;
    // dłuższy quiz
    if (totalQuestions >= 10) xp += 15;

    return xp;
  };

  // --- KONIEC SESJI (zapis wyniku + XP + poziom) ---
  const finishSession = async (allAnswers) => {
    const score = allAnswers.filter((a) => a.isCorrect).length;
    const timeSpent = sessionStartTime
      ? Math.round((Date.now() - sessionStartTime) / 1000)
      : null;
    const percentage =
      allAnswers.length > 0
        ? Math.round((score / allAnswers.length) * 100)
        : 0;

    // zapisz wynik quizu
    if (sessionId) {
      try {
        await fetch(`${API_BASE}/results.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: sessionId,
            total_questions: questions.length,
            correct_answers: score,
            time_spent: timeSpent,
            percentage: percentage,
          }),
        });
      } catch (error) {
        console.error('Błąd zapisywania wyniku:', error);
      }
    }

    // XP i prog. gracza
    const xp = calculateXP(score, questions.length, timeSpent || 0, percentage);
    setEarnedXP(xp);

    try {
      const gamResponse = await fetch(`${API_BASE}/gamification.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'add_xp',
          student_name: studentName,
          xp: xp,
          session_id: sessionId,
          percentage: percentage,
          time_spent: timeSpent,
        }),
      });

      const gamData = await gamResponse.json();

      if (gamData.success) {
        setStudentProgress(gamData.data.progress);
        setLevelUp(gamData.data.level_up || false);
        setNewBadges(gamData.data.new_badges || []);
        setShowXPAnimation(true);

        // schowaj animację po chwili
        setTimeout(() => setShowXPAnimation(false), 3000);
      }
    } catch (error) {
      console.error('Błąd zapisu gamifikacji:', error);
    }

    setStage('results');
  };

  // RESET / NOWA SESJA
  const restart = () => {
    setStage('name');
    setStudentName('');
    setSessionId(null);
    setMaterial('');
    setTextInput('');
    setQuestions([]);
    setCurrentQuestion(0);
    setAnswers([]);
    setUserAnswer('');
    setSelectedOption(null);
    setUploadedImage(null);
    setStudentStats(null);

    // gamification UI cleanup
    setEarnedXP(0);
    setLevelUp(false);
    setNewBadges([]);
  };

  // --- COMPONENTY GAMI ---
  const XPAnimation = () => {
    if (!showXPAnimation) return null;
    return (
      <div className="xp-animation fixed top-4 right-4 z-50 flex items-center gap-2 bg-yellow-100 border border-yellow-300 rounded-lg px-4 py-2 shadow-lg">
        <Zap className="xp-icon w-5 h-5 text-yellow-600" />
        <span className="xp-amount font-semibold text-yellow-800">
          +{earnedXP} XP
        </span>
      </div>
    );
  };

  const LevelBadge = () => {
    if (!studentProgress) return null;

    const level = studentProgress.level;
    const xpTotal = studentProgress.total_xp;
    const xpProgress = xpTotal % 100;
    const nextLevel = level + 1;

    return (
      <div className="level-badge flex items-center gap-3 bg-indigo-50 border border-indigo-200 rounded-lg p-3 text-sm">
        <div className="relative flex items-center justify-center w-12 h-12 rounded-full bg-indigo-600 text-white font-bold shadow-lg">
          <Star className="level-icon w-4 h-4 absolute -top-1 -right-1 text-yellow-300 drop-shadow" />
          <span className="level-number text-lg leading-none">{level}</span>
        </div>
        <div className="flex-1">
          <div className="level-bar w-full bg-gray-200 rounded-full h-2 mb-1 overflow-hidden">
            <div
              className="level-fill bg-indigo-600 h-2"
              style={{ width: `${xpProgress}%` }}
            />
          </div>
          <span className="level-text text-gray-700 text-xs">
            {xpProgress}/100 XP do poziomu {nextLevel}
          </span>
        </div>
      </div>
    );
  };

  const BadgesDisplay = ({ badges }) => {
    if (!badges || badges.length === 0) return null;
    return (
      <div className="badges-container bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
        <h4 className="font-semibold text-yellow-800 flex items-center gap-2 mb-2">
          <Award className="w-4 h-4 text-yellow-600" />
          Twoje odznaki
        </h4>
        <div className="badges-grid grid grid-cols-1 sm:grid-cols-2 gap-3">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="badge-item bg-white border border-yellow-300 rounded-lg p-3 text-sm"
            >
              <div className="badge-icon text-lg font-bold text-yellow-600">
                {badge.icon || '🏅'}
              </div>
              <div className="badge-name font-semibold text-gray-800">
                {badge.name}
              </div>
              <div className="badge-description text-gray-600 text-xs">
                {badge.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Pasek postępu pytania w trakcie quizu
  const ProgressBar = ({ current, total }) => (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-semibold text-gray-600">
          Pytanie {current} z {total}
        </span>
        <span className="text-xs font-semibold text-indigo-700 bg-indigo-100 px-2 py-1 rounded">
          {Math.round((current / total) * 100)}%
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-indigo-600 h-2 rounded-full transition-all"
          style={{ width: `${(current / total) * 100}%` }}
        />
      </div>
    </div>
  );

  // Panel konfiguracji quizu
  const QuestionConfigPanel = () => (
    <div className="config-panel bg-white border border-gray-200 rounded-lg p-4 shadow-sm mb-4">
      <h3 className="font-semibold text-gray-800 flex items-center gap-2 mb-4">
        <span role="img" aria-label="ustawienia">
          ⚙️
        </span>
        Konfiguracja quizu
      </h3>

      <div className="config-item mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Liczba pytań:
        </label>

        <div className="flex gap-2 flex-wrap mb-3">
          {[3, 6, 9, 12, 15].map((count) => (
            <button
              key={count}
              className={`px-3 py-1.5 rounded text-sm font-semibold border transition ${
                questionCount === count
                  ? 'bg-indigo-600 text-white border-indigo-600'
                  : 'bg-white text-gray-700 border-gray-300 hover:border-indigo-400 hover:text-indigo-600'
              }`}
              onClick={() => setQuestionCount(count)}
            >
              {count}
            </button>
          ))}
        </div>

        <input
          type="range"
          min="3"
          max="20"
          value={questionCount}
          onChange={(e) => setQuestionCount(parseInt(e.target.value))}
          className="w-full"
        />
        <div className="text-xs text-gray-600 mt-1">
          Aktualnie: {questionCount} pytań
        </div>
      </div>

      <div className="config-item">
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={useAI}
            onChange={(e) => setUseAI(e.target.checked)}
            className="w-5 h-5 text-indigo-600 rounded mt-0.5"
          />
          <div>
            <div className="font-semibold text-gray-800">
              🤖 Użyj AI do generowania pytań
            </div>
            {useAI && (
              <p className="text-sm text-gray-600">
                AI wygeneruje lepsze, bardziej zróżnicowane pytania i dokładniej
                oceni odpowiedzi
              </p>
            )}
          </div>
        </label>
      </div>
    </div>
  );

  // --- RENDER PYTANIA (input dla aktualnego pytania) ---
  const renderQuestionInput = () => {
    const q = questions[currentQuestion];
    if (!q) return null;

    if (q.type === 'open') {
      return (
        <textarea
          className="w-full border-2 border-gray-300 rounded-lg p-4 mb-4 focus:border-indigo-500 focus:outline-none"
          rows="4"
          placeholder="Wpisz swoją odpowiedź..."
          value={userAnswer}
          onChange={(e) => setUserAnswer(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && e.ctrlKey && submitAnswer()}
        />
      );
    } else if (q.type === 'multiple') {
      return (
        <div className="space-y-3 mb-4">
          {q.options.map((option, i) => (
            <button
              key={i}
              onClick={() => setSelectedOption(i)}
              className={`w-full text-left p-4 rounded-lg border-2 transition ${
                selectedOption === i
                  ? 'border-indigo-500 bg-indigo-50'
                  : 'border-gray-300 hover:border-indigo-300'
              }`}
            >
              <span className="font-semibold text-indigo-600 mr-2">
                {String.fromCharCode(65 + i)}.
              </span>
              {option}
            </button>
          ))}
        </div>
      );
    } else if (q.type === 'truefalse') {
      return (
        <div className="flex gap-4 mb-4">
          <button
            onClick={() => setSelectedOption('true')}
            className={`flex-1 p-6 rounded-lg border-2 transition ${
              selectedOption === 'true'
                ? 'border-green-500 bg-green-50'
                : 'border-gray-300 hover:border-green-300'
            }`}
          >
            <CheckCircle className="w-8 h-8 mx-auto mb-2 text-green-600" />
            <p className="text-center font-semibold">Prawda</p>
          </button>
          <button
            onClick={() => setSelectedOption('false')}
            className={`flex-1 p-6 rounded-lg border-2 transition ${
              selectedOption === 'false'
                ? 'border-red-500 bg-red-50'
                : 'border-gray-300 hover:border-red-300'
            }`}
          >
            <XCircle className="w-8 h-8 mx-auto mb-2 text-red-600" />
            <p className="text-center font-semibold">Fałsz</p>
          </button>
        </div>
      );
    }
  };

  const canSubmit = () => {
    const q = questions[currentQuestion];
    if (!q) return false;
    if (q.type === 'open') return userAnswer.trim().length > 0;
    return selectedOption !== null;
  };

  // --- WYNIKI I PROCENT ---
  const score = answers.filter((a) => a.isCorrect).length;
  const percentage =
    answers.length > 0
      ? Math.round((score / answers.length) * 100)
      : 0;

  // --- RENDER JSX ---
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4 relative">
      {/* XP popup */}
      <XPAnimation />

      <div className="max-w-3xl mx-auto">
        {/* HEADER */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 flex-wrap justify-between">
            <div className="flex items-center gap-3">
              <BookOpen className="w-8 h-8 text-indigo-600" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">
                  Nauczyciel AI
                </h1>
                <p className="text-gray-600 mt-1 text-sm">
                  Ucz się przez zadawanie pytań! 🚀
                </p>
              </div>
            </div>

            {/* Poziom / XP gracza (jeśli znany) */}
            {studentProgress && (
              <div className="w-full sm:w-auto">
                <LevelBadge />
              </div>
            )}
          </div>
        </div>

        {/* STAGE: PODAJ IMIĘ */}
        {stage === 'name' && (
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-6">
              <User className="w-16 h-16 text-indigo-600 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                Witaj!
              </h2>
              <p className="text-gray-600">Jak masz na imię?</p>
            </div>

            <input
              type="text"
              className="w-full border-2 border-gray-300 rounded-lg p-4 mb-4 text-center text-lg focus:border-indigo-500 focus:outline-none"
              placeholder="Wpisz swoje imię..."
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && startSession()}
              autoFocus
            />

            {/* Statystyki ucznia */}
            {studentStats && (
              <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 mb-4">
                <div className="flex items-center gap-2 mb-2">
                  <BarChart3 className="w-5 h-5 text-indigo-600" />
                  <p className="font-semibold text-indigo-900">
                    Twoje statystyki:
                  </p>
                </div>
                <div className="grid grid-cols-3 gap-3 text-center">
                  <div>
                    <p className="text-2xl font-bold text-indigo-600">
                      {studentStats.total_sessions}
                    </p>
                    <p className="text-xs text-gray-600">Sesji</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-indigo-600">
                      {studentStats.avg_percentage ?? studentStats.avg_score}%
                    </p>
                    <p className="text-xs text-gray-600">Średnia</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-indigo-600">
                      {studentStats.best_score}%
                    </p>
                    <p className="text-xs text-gray-600">Najlepszy</p>
                  </div>
                </div>
              </div>
            )}

            {/* Poziom / XP */}
            {studentProgress && (
              <div className="mb-4">
                <LevelBadge />
              </div>
            )}

            <button
              onClick={startSession}
              disabled={!studentName.trim()}
              className="w-full bg-indigo-600 text-white py-4 rounded-lg font-semibold text-lg hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition"
            >
              Rozpocznij naukę! 🚀
            </button>
          </div>
        )}

        {/* STAGE: DODANIE MATERIAŁU */}
        {stage === 'upload' && (
          <div className="bg-white rounded-lg shadow-lg p-6 space-y-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-800">
                Cześć {studentName}! 👋
              </h2>
              <button
                onClick={() => setStage('name')}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Zmień imię
              </button>
            </div>

            
{/* Biblioteka materiałów (globalna dla wszystkich) */}
{studentMaterials.length > 0 && (
  <div className="mb-4">
    <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
      🌍 Biblioteka materiałów
      <span className="text-sm font-normal text-gray-500">
        (dostępne dla wszystkich uczniów)
      </span>
    </h3>
    
    {/* OPCJONALNE: Pole wyszukiwania */}
    {studentMaterials.length > 5 && (
      <div className="mb-3">
        <input
          type="text"
          placeholder="🔍 Szukaj materiału... (np. 'historia', 'Warszawa')"
          value={materialSearchQuery || ''}
          onChange={(e) => setMaterialSearchQuery(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
        />
      </div>
    )}
    
    <div className="space-y-3 max-h-96 overflow-y-auto">
      {studentMaterials
        .filter(mat => 
          !materialSearchQuery || 
          mat.material_text.toLowerCase().includes(materialSearchQuery.toLowerCase()) ||
          (mat.created_by && mat.created_by.toLowerCase().includes(materialSearchQuery.toLowerCase()))
        )
        .map((mat, idx) => (
          <div
            key={idx}
            className="border border-gray-300 rounded-lg p-3 hover:shadow-md transition bg-white"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-700 line-clamp-2 mb-2">
                  {mat.material_text.substring(0, 100)}
                  {mat.material_text.length > 100 && '...'}
                </p>
                <div className="text-xs text-gray-500 space-x-2 flex flex-wrap gap-1">
                  <span>
                    {new Date(mat.created_at).toLocaleDateString('pl-PL')}
                  </span>
                  <span>•</span>
                  <span>{mat.material_length} znaków</span>
                  
                  {/* NOWE: Informacja kto dodał materiał */}
                  {mat.created_by && (
                    <>
                      <span>•</span>
                      <span className="text-purple-600 font-semibold">
                        📝 Dodał: {mat.created_by}
                      </span>
                    </>
                  )}
                  
                  {mat.usage_count > 1 && (
                    <>
                      <span>•</span>
                      <span className="text-indigo-600 font-semibold">
                        🔄 Używano {mat.usage_count}x
                      </span>
                    </>
                  )}
                  
                  {mat.last_percentage !== null && (
                    <>
                      <span>•</span>
                      <span
                        className="font-semibold"
                        style={{
                          color:
                            mat.last_percentage >= 70
                              ? '#059669'
                              : mat.last_percentage >= 50
                              ? '#d97706'
                              : '#dc2626',
                        }}
                      >
                        📊 Ostatnio: {mat.last_percentage}%
                      </span>
                    </>
                  )}
                </div>
              </div>
              <button
                onClick={() => loadPreviousMaterial(mat.material_text)}
                className="flex-shrink-0 bg-indigo-600 text-white px-3 py-1.5 rounded text-sm font-semibold hover:bg-indigo-700 transition"
              >
                Użyj ponownie
              </button>
            </div>
          </div>
        ))}
      
      {/* Informacja gdy brak wyników wyszukiwania */}
      {materialSearchQuery && studentMaterials.filter(mat => 
        mat.material_text.toLowerCase().includes(materialSearchQuery.toLowerCase()) ||
        (mat.created_by && mat.created_by.toLowerCase().includes(materialSearchQuery.toLowerCase()))
      ).length === 0 && (
        <div className="text-center py-8 text-gray-500">
          <p>🔍 Nie znaleziono materiałów pasujących do "{materialSearchQuery}"</p>
          <button
            onClick={() => setMaterialSearchQuery('')}
            className="mt-2 text-indigo-600 hover:text-indigo-700 font-semibold"
          >
            Wyczyść wyszukiwanie
          </button>
        </div>
      )}
    </div>
  </div>
)}


            {/* Panel konfiguracji quizu (gamifikacja / AI / liczba pytań) */}
            <div>
              <button
                onClick={() => setShowConfig(!showConfig)}
                className="w-full text-left bg-indigo-100 border border-indigo-300 rounded-lg px-4 py-3 font-semibold text-indigo-800 hover:bg-indigo-200 transition flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <span role="img" aria-label="ustawienia">
                    ⚙️
                  </span>
                  Ustawienia quizu
                </span>
                <span className="text-sm text-indigo-700">
                  {showConfig ? 'Ukryj' : 'Pokaż'}
                </span>
              </button>

              {showConfig && <QuestionConfigPanel />}
            </div>

            {/* Strefa uploadu / OCR */}
            <div
              className={`border-2 border-dashed rounded-lg p-8 text-center mb-4 transition ${
                isProcessingOCR
                  ? 'border-indigo-500 bg-indigo-50'
                  : uploadedImage
                  ? 'border-green-400 bg-green-50'
                  : 'border-indigo-300 hover:border-indigo-500'
              }`}
            >
              {isProcessingOCR ? (
                <div>
                  <Loader className="w-12 h-12 text-indigo-600 mx-auto mb-3 animate-spin" />
                  <p className="text-indigo-700 font-semibold mb-2">
                    Rozpoznawanie tekstu...
                  </p>
                  <div className="w-full bg-indigo-200 rounded-full h-3 max-w-xs mx-auto">
                    <div
                      className="bg-indigo-600 h-3 rounded-full transition-all"
                      style={{ width: `${ocrProgress}%` }}
                    />
                  </div>
                  <p className="text-indigo-600 text-sm mt-2">
                    {ocrProgress}%
                  </p>
                </div>
              ) : uploadedImage ? (
                <div>
                  <CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-3" />
                  <p className="text-green-700 font-semibold">
                    Zdjęcie przetworzone!
                  </p>
                  <p className="text-green-600 text-sm">
                    Sprawdź rozpoznany tekst poniżej
                  </p>
                  <button
                    onClick={() => {
                      setUploadedImage(null);
                      setTextInput('');
                      setMaterial('');
                    }}
                    className="mt-3 text-red-600 hover:text-red-700 text-sm underline"
                  >
                    Usuń i spróbuj ponownie
                  </button>
                </div>
              ) : (
                <div className="space-y-4">
                  <Camera className="w-12 h-12 text-indigo-400 mx-auto" />
                  <p className="text-gray-700 font-semibold">
                    Dodaj zdjęcie z podręcznika
                  </p>

                  <div className="flex gap-3 justify-center flex-wrap">
                    <label className="cursor-pointer bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition inline-flex items-center gap-2 font-semibold">
                      <Camera className="w-5 h-5" />
                      Zrób zdjęcie
                      <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        capture="environment"
                        onChange={handleImageUpload}
                        disabled={isProcessingOCR}
                      />
                    </label>

                    <label className="cursor-pointer bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition inline-flex items-center gap-2 font-semibold">
                      <Upload className="w-5 h-5" />
                      Wybierz z galerii
                      <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageUpload}
                        disabled={isProcessingOCR}
                      />
                    </label>
                  </div>

                  <p className="text-gray-500 text-sm">
                    Automatyczne OCR w języku polskim
                  </p>
                </div>
              )}
            </div>

            {uploadedImage && !isProcessingOCR && (
              <div className="mb-4">
                <img
                  src={uploadedImage}
                  alt="Przesłane zdjęcie"
                  className="w-full max-h-64 object-contain rounded-lg border-2 border-gray-300"
                />
              </div>
            )}

            {/* DODANO 2025-10-26 14:40: Komponent wyboru poziomu trudności */}
            <DifficultySelector 
              value={difficultyLevel}
              onChange={setDifficultyLevel}
            />

            {/* Tekst rozpoznany / ręczny */}
            <div className="mb-4">
              <div className="flex items-center gap-2 mb-2">
                <FileText className="w-5 h-5 text-indigo-600" />
                <span className="font-semibold text-gray-700">
                  {uploadedImage
                    ? 'Rozpoznany tekst (możesz edytować):'
                    : 'Lub wklej tekst ręcznie:'}
                </span>
              </div>
              <textarea
                className="w-full border-2 border-gray-300 rounded-lg p-3 focus:border-indigo-500 focus:outline-none"
                rows="8"
                placeholder="Tekst pojawi się tutaj automatycznie lub wklej ręcznie..."
                value={textInput}
                onChange={(e) => setTextInput(e.target.value)}
                disabled={isProcessingOCR}
              />
              {!uploadedImage && (
                <button
                  onClick={handleTextSubmit}
                  disabled={isProcessingOCR}
                  className="mt-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition disabled:bg-gray-400"
                >
                  Użyj tego tekstu
                </button>
              )}
            </div>

            {material && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                <p className="font-semibold text-green-800 mb-2">
                  ✓ Materiał załadowany ({material.length} znaków):
                </p>
                <p className="text-gray-700 text-sm max-h-32 overflow-y-auto">
                  {material}
                </p>
              </div>
            )}

            <button
              onClick={startLearning}
              disabled={!material || isProcessingOCR || isGeneratingAI}
              className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition flex items-center justify-center gap-2"
            >
              {isGeneratingAI ? (
                <>
                  <Loader className="w-5 h-5 animate-spin" />
                  AI generuje pytania...
                </>
              ) : (
                <>
                  Zacznij naukę! 🚀
                  <span className="text-sm font-normal text-indigo-200">
                    ({questionCount} pytań)
                  </span>
                </>
              )}
            </button>
          </div>
        )}

        {/* STAGE: QUIZ */}
        {stage === 'learning' && questions.length > 0 && (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <ProgressBar
              current={currentQuestion + 1}
              total={questions.length}
            />

            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-semibold text-gray-600">
                Typ pytania:
              </span>
              <span
                className={`text-sm px-3 py-1 rounded-full ${
                  questions[currentQuestion].type === 'open'
                    ? 'bg-blue-100 text-blue-700'
                    : questions[currentQuestion].type === 'multiple'
                    ? 'bg-purple-100 text-purple-700'
                    : 'bg-orange-100 text-orange-700'
                }`}
              >
                {questions[currentQuestion].type === 'open'
                  ? 'Pytanie otwarte'
                  : questions[currentQuestion].type === 'multiple'
                  ? 'Wielokrotny wybór'
                  : 'Prawda/Fałsz'}
              </span>
            </div>

            <div className="bg-indigo-50 rounded-lg p-6 mb-6">
              <h3 className="text-2xl font-bold text-indigo-900">
                {questions[currentQuestion].question}
              </h3>
            </div>

            {renderQuestionInput()}

            <button
              onClick={submitAnswer}
              disabled={!canSubmit()}
              className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition flex items-center justify-center gap-2"
            >
              <Send className="w-5 h-5" />
              Sprawdź odpowiedź
            </button>

            {questions[currentQuestion].type === 'open' && (
              <p className="text-gray-500 text-sm text-center mt-2">
                Możesz też nacisnąć Ctrl+Enter
              </p>
            )}
          </div>
        )}

        {/* STAGE: WYNIKI */}
        {stage === 'results' && (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="text-center mb-6">
              <div
                className={`inline-block p-4 rounded-full mb-4 ${
                  percentage >= 70
                    ? 'bg-green-100'
                    : percentage >= 50
                    ? 'bg-yellow-100'
                    : 'bg-red-100'
                }`}
              >
                <span className="text-4xl">
                  {percentage >= 70
                    ? '🎉'
                    : percentage >= 50
                    ? '👍'
                    : '💪'}
                </span>
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">
                Twój wynik
              </h2>
              <p className="text-5xl font-bold text-indigo-600 mb-2">
                {percentage}%
              </p>
              <p className="text-gray-600">
                {score} z {answers.length} poprawnych odpowiedzi
              </p>
            </div>

            {/* NOWE: komunikaty gamifikacji */}
            {levelUp && studentProgress && (
              <div className="level-up-notification bg-yellow-50 border border-yellow-300 rounded-lg p-4 mb-4 text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Trophy className="trophy-icon w-6 h-6 text-yellow-600" />
                  <h3 className="text-xl font-bold text-yellow-800">
                    AWANS NA POZIOM {studentProgress.level}!
                  </h3>
                </div>
                <p className="text-yellow-700 text-sm">
                  Jesteś coraz silniejszy w nauce 💪
                </p>
              </div>
            )}

            {newBadges.length > 0 && (
              <div className="new-badges mb-4">
                <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2 mb-2">
                  <Award className="w-5 h-5 text-yellow-600" />
                  Nowe odznaki! 🎖️
                </h3>
                <BadgesDisplay badges={newBadges} />
              </div>
            )}

            <div className="xp-earned flex items-center justify-center gap-3 bg-indigo-50 border border-indigo-200 rounded-lg p-4 mb-6 text-indigo-800 font-semibold text-lg">
              <Zap className="xp-icon-large w-6 h-6 text-indigo-600" />
              <span>Zdobyłeś {earnedXP} XP!</span>
            </div>

            {studentProgress && (
              <div className="mb-6">
                <LevelBadge />
              </div>
            )}

            {/* Lista odpowiedzi */}
            <div className="space-y-4 mb-6">
              {answers.map((answer, i) => (
                <div
                  key={i}
                  className={`border-l-4 p-4 rounded ${
                    answer.isCorrect
                      ? 'border-green-500 bg-green-50'
                      : 'border-red-500 bg-red-50'
                  }`}
                >
                  <div className="flex items-start gap-2">
                    {answer.isCorrect ? (
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    ) : (
                      <XCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    )}
                    <div className="flex-1">
                      <span
                        className={`text-xs px-2 py-1 rounded mb-2 inline-block ${
                          answer.type === 'open'
                            ? 'bg-blue-100 text-blue-700'
                            : answer.type === 'multiple'
                            ? 'bg-purple-100 text-purple-700'
                            : 'bg-orange-100 text-orange-700'
                        }`}
                      >
                        {answer.type === 'open'
                          ? 'Otwarte'
                          : answer.type === 'multiple'
                          ? 'Wybór'
                          : 'P/F'}
                      </span>
                      <p className="font-semibold text-gray-800 mb-1">
                        {answer.question}
                      </p>
                      <p className="text-gray-700 text-sm mb-1">
                        <strong>Twoja odpowiedź:</strong>{' '}
                        {answer.userAnswer}
                      </p>
                      {!answer.isCorrect && (
                        <>
                          <p className="text-gray-600 text-sm">
                            <strong>Poprawna odpowiedź:</strong>{' '}
                            {answer.correctAnswer}
                          </p>
                          {answer.feedback && (
                            <p className="text-indigo-600 text-sm mt-1">
                              <strong>💡 Wskazówka AI:</strong>{' '}
                              {answer.feedback}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={restart}
              className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 transition"
            >
              Rozpocznij nową sesję
            </button>
          </div>
        )}
      </div>

      {/* Stopka z linkiem do admina */}
      <div className="text-center mt-8 pb-4">
        <div className="text-xs text-gray-400 space-x-2">
          <span>Nauczyciel AI</span>
          <span>•</span>
          <a
            href="admin.html"
            className="hover:text-indigo-600 transition underline decoration-dotted"
          >
            Panel
          </a>
        </div>
      </div>
    </div>
  );
}